import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";
import { evaluatePassword } from "../lib/passwordPolicy";

export default function PasswordStrengthMeter({ password }) {
  const { t } = useTranslation();
  const { checks, level } = evaluatePassword(password);
  if (!password) return null;

  const barColor =
    level === "green" ? "bg-emerald-500" : level === "yellow" ? "bg-amber-500" : "bg-red-500";
  const barWidth = level === "green" ? "100%" : level === "yellow" ? "66%" : "33%";
  const label =
    level === "green" ? t("security.strength.strong") :
    level === "yellow" ? t("security.strength.ok") : t("security.strength.weak");

  const Req = ({ ok, text }) => (
    <li className={`flex items-center gap-1.5 ${ok ? "text-emerald-600" : "text-slate-400"}`}>
      {ok ? <Check className="w-3.5 h-3.5" /> : <X className="w-3.5 h-3.5" />} {text}
    </li>
  );

  return (
    <div data-testid="password-strength-meter" className="mt-2">
      <div className="h-1.5 w-full bg-slate-200 rounded-full overflow-hidden">
        <div className={`h-full ${barColor} transition-all`} style={{ width: barWidth }} />
      </div>
      <div className="flex justify-between items-center mt-1">
        <span className={`text-[11px] font-bold ${level === "green" ? "text-emerald-600" : level === "yellow" ? "text-amber-600" : "text-red-500"}`}>
          {label}
        </span>
      </div>
      <ul className="grid grid-cols-2 gap-x-3 gap-y-0.5 mt-1.5 text-[11px]">
        <Req ok={checks.length} text={t("security.req.length")} />
        <Req ok={checks.upper} text={t("security.req.upper")} />
        <Req ok={checks.lower} text={t("security.req.lower")} />
        <Req ok={checks.digit} text={t("security.req.digit")} />
        <Req ok={checks.symbol} text={t("security.req.symbol")} />
      </ul>
    </div>
  );
}
